import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '@/services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.ContactGroupsResponse,
  fetchData: (params: vp.TimezoneRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchContactGroups: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [response, setResponse] = useState<vp.ContactGroupsResponse>({
    Success: false,
    ErrorMessage: '',
    ContactGroups: {},
  });
  const [shouldFetchData, setShouldFetchData] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.TimezoneRequest>({});
  useEffect(() => {
    if (!shouldFetchData) return () => {};

    const loadData = async () => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.fetchContactGroups(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };
    if (shouldFetchData) void loadData();
    setShouldFetchData(false);
    return () => {
      source.cancel();
    };
  }, [shouldFetchData]);

  return [
    response,
    (params: vp.TimezoneRequest) => {
      setParams(params);
      setShouldFetchData(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        ContactGroups: {},
      });
      setShouldFetchData(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchContactGroups);
